import { Directive,ElementRef,Renderer2, Input, OnChanges, SimpleChanges, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { COMPONENT_UI } from '../workflow-components.models';

@Directive({ selector: '[abwConditionalFormating]' })
export class AbwConditionalFormatingDirective implements OnChanges {
    @Input() formatStyle: { BACKGROUND_COLOR: string, TEXT_COLOR: string } = null;
    @Input() formatProperty: 'backgroundColor' | 'color';
	@Input() componentUI = COMPONENT_UI.IONIC;
    domElement: any;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef
    ) {
        this.domElement = this.elementRef.nativeElement;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!this.domElement.style) {
            if (this.formatProperty == 'color') { this.domElement.style.setProperty('color', this.formatStyle?.TEXT_COLOR ?? ''); }
            else if (this.formatProperty == 'backgroundColor') { 
                this.domElement.style.setProperty(this.componentUI == COMPONENT_UI.KENDO || this.componentUI == COMPONENT_UI.IONIC ? '--ion-item-background' : 'background-color', this.formatStyle?.BACKGROUND_COLOR ?? '') 
            }
        }
    }
}

@NgModule({
    declarations: [AbwConditionalFormatingDirective],
    imports: [CommonModule],
    exports: [AbwConditionalFormatingDirective]
})
export class AbwConditionalFormatingModule {}